import { navigationTypes } from '../Constants';

export const getFyndNavigationType = (webNavigations, navigationType, storeName = 'AJIO') => {
  if (!webNavigations?.isEnabled) return navigationType;

  const storeNav = webNavigations?.stores?.[storeName.toLowerCase()];
  switch (navigationType) {
    case navigationTypes.CATEGORIES:
      return storeNav?.categories?.name || navigationType;
    case navigationTypes.TOP_BAR:
    case navigationTypes.TOP_BAR_2:
      return storeNav?.topBar?.name || navigationType;
    case navigationTypes.BOTTOM_BAR:
    case navigationTypes.BOTTOM_BAR_2:
      return storeNav?.bottomBar?.name || navigationType;
    default:
      return navigationType;
  }
};
